import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Steps back through the browser history when the current page was reached by in-app navigation,
 * otherwise navigates to `fallbackPath`. React Router keys the session's first location as 'default'.
 */
export function useBackNavigation() {
	const navigate = useNavigate();
	const { key } = useLocation();
	const hasAppHistory = key !== 'default';
	const goBack = useCallback((fallbackPath: string) => {
		if (hasAppHistory) navigate(-1);
		else navigate(fallbackPath);
	}, [hasAppHistory, navigate]);
	return goBack;
}
